import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";
import CcChip from "./CcChip";

/**
 * Section tabs — MUI Tabs + Carecentre theme.
 */
const CcTabs = ({ items = [], activeKey, onChange, className }) => {
  const activeIndex = Math.max(
    0,
    items.findIndex((item) => item.key === activeKey),
  );

  const handleChange = (_, index) => {
    const item = items[index];
    if (item) {
      onChange?.(item);
    }
  };

  return (
    <Tabs
      className={className}
      value={activeIndex}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
    >
      {items.map((item) => (
        <Tab
          key={item.key}
          label={
            <Box alignItems="center" display="inline-flex" style={{ gap: 8 }}>
              <span>{item.label}</span>
              {item.count !== undefined ? (
                <CcChip label={String(item.count)} tone="active" />
              ) : null}
            </Box>
          }
        />
      ))}
    </Tabs>
  );
};

export default CcTabs;
